<template>
  <div class="d-flex align-items-center justify-content-center min-vh-100" style="background:#f0f4f8;">
    <div class="card shadow-lg border-0 p-4" style="max-width:400px;width:100%;">
      <div class="text-center mb-4">
        <svg width="56" height="56" fill="none" viewBox="0 0 48 48" class="mb-2"><rect width="48" height="48" rx="12" fill="#0d6efd"/><path d="M24 14c-5.5 0-10 4.5-10 10s4.5 10 10 10 10-4.5 10-10-4.5-10-10-10zm0 16c-3.3 0-6-2.7-6-6s2.7-6 6-6 6 2.7 6 6-2.7 6-6 6zm-8 4h16v2H16z" fill="#fff"/></svg>
        <h4 class="fw-bold mb-0">PoolFit Admin</h4>
        <div class="text-muted small">Sign in to continue</div>
      </div>
      <div class="alert alert-danger" v-if="loginError" role="alert">
        Please check your login credentials and try again!
      </div>
      <form @submit.prevent="login">
        <div class="mb-3">
          <label for="email" class="form-label">Email</label>
          <input class="form-control form-control-lg" type="email" placeholder="Enter your email" id="email" v-model="email" autocomplete="username" required />
        </div>
        <div class="mb-3">
          <label for="password" class="form-label">Password</label>
          <input class="form-control form-control-lg" type="password" placeholder="Enter your password" id="password" v-model="password" autocomplete="current-password" required />
        </div>
        <div class="form-check mb-3">
          <input class="form-check-input" type="checkbox" id="rememberMe" v-model="rememberMe" />
          <label class="form-check-label small" for="rememberMe">Remember me</label>
        </div>
        <div class="d-grid mt-2">
          <button class="btn btn-primary btn-lg" type="submit">Sign In</button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import AccountService from "../services/AccountService";
import authStorage from "../utils/authStorage";

export default {
  data() {
    const saved = (() => {
      try { return JSON.parse(localStorage.getItem('pf_remember')); } catch { return null; }
    })();
    return {
      email: saved?.email || '',
      password: saved?.password || '',
      rememberMe: !!saved,
      loginError: false
    };
  },

  methods: {
    async login() {
      this.loginError = false;
      try {
        const response = await AccountService.login({ email: this.email, password: this.password });
        if (response.data.customer_profile.permission === "admin") {
          if (this.rememberMe) {
            localStorage.setItem('pf_remember', JSON.stringify({ email: this.email, password: this.password }));
          } else {
            localStorage.removeItem('pf_remember');
          }
          authStorage.setTokens(response.data);
          this.$router.push("/");
        } else {
          this.loginError = true;
        }
      } catch (err) {
        this.loginError = true;
        authStorage.clearSession();
      }
    }
  }
};
</script>
<style></style>
